import { Injectable } from '@angular/core';
import { MimeTypes } from 'src/app/_enums';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  constructor() {}
  fileMimeTypeChecker(fileMimeType: string): { iconUrl: string; mimeType: number } {
    if (!fileMimeType) return { iconUrl: 'assets/Icons/unknown.png', mimeType: MimeTypes.Unknown };
    if (fileMimeType.includes('image')) return { iconUrl: 'assets/Icons/Gallery.png', mimeType: MimeTypes.Image };
    if (fileMimeType.includes('video')) return { iconUrl: 'assets/Icons/avi.png', mimeType: MimeTypes.Video };
    if (fileMimeType.includes('audio')) return { iconUrl: 'assets/Icons/mp3.png', mimeType: MimeTypes.Audio };
    if (fileMimeType.includes('compressed')) return { iconUrl: 'assets/Icons/ic-zip.png', mimeType: MimeTypes.Compressed };
    if (fileMimeType.includes('word')) return { iconUrl: 'assets/Icons/word.png', mimeType: MimeTypes.Word };
    if (fileMimeType.includes('presentation') || fileMimeType.includes('powerpoint'))
      return { iconUrl: 'assets/Icons/powerpoint.png', mimeType: MimeTypes.PresentationAndPowerpoint };
    if (fileMimeType.includes('excel') || fileMimeType.includes('sheet'))
      return { iconUrl: 'assets/Icons/excel.png', mimeType: MimeTypes.ExcelAndSheet };
    if (fileMimeType.includes('pdf')) return { iconUrl: 'assets/Icons/pdf.png', mimeType: MimeTypes.Pdf };
    if (fileMimeType.includes('html')) return { iconUrl: 'assets/Icons/html.png', mimeType: MimeTypes.Html };
    if (fileMimeType.includes('text')) return { iconUrl: 'assets/Icons/file.png', mimeType: MimeTypes.Text };
    if (fileMimeType.includes('exe')) return { iconUrl: 'assets/Icons/exe.png', mimeType: MimeTypes.Exe };
    return { iconUrl: 'assets/Icons/unknown.png', mimeType: MimeTypes.Unknown };
  }
}
